//use rfce
import React from 'react'
//import css file of it
import styles from './Home.module.css'
import { Button } from '@material-ui/core'
import img2 from './distancing.jpg'
import { NavLink } from 'react-router-dom'
import Typewriter from 'typewriter-effect'


function Home() {

    


    return (
        <div className={styles.main_section1}>
        <div className={styles.section2}>
            <div className={styles.container_home}>
                <div className={styles.content1_section}>
                <div className={styles.title1}>
                    <h1><Typewriter onInit={(typewriter)=>{
                        typewriter
                        .typeString("My Covid  Tracker WebApp")
                        .pauseFor(10000)
                        .start();
                    }}/></h1>
                </div>

                <div className={styles.content1}>
                    <h3>_by <strong>Anupam Ghosh</strong></h3> 
                    <p>Using react js framework and simple css with the help Covid Api.
                        Here I use axios to fetch Api Data.This WebApp shows daily total no. of records of covid-19,
                        Globally and Countrywise separately upto present date.
                    </p>         
                    <NavLink to="/globaldata" className={styles.btn1}>Let's Go..</NavLink>

                </div>

                </div>

                <div className={styles.image_section1}>
                    <img src={img2} alt="social_distancing"/>
                </div>
            </div>

        </div>

    

        </div>
    )
}

export default Home
